import { useEffect } from 'react'
import MonthlyActivity from '../components/widgets/MonthlyActivity'
import RecentLeads from '../components/widgets/RecentLeads'
// import ActiveAds from '../components/widgets/ActiveAds'
import MonthlyAnalytics from '../components/widgets/MonthlyAnalytics'
import ActiveListings from '../components/widgets/ActiveListings'

import { Box, Grid, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import AlertNotification from '../components/AlertNotification/AlertNotification'
import { useLocation } from 'react-router-dom'
import useIHFlink from '../hooks/useIHFlink'
import useToken from '../hooks/useToken'
import { type IUserProfile } from '../redux/api/types'
import { useSelector } from 'react-redux'
import { PROFILE_TYPE_BUSINESS } from '../utils/constants/profile'

const HomePage: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const location = useLocation()
  const { xsrf } = useToken()
  const { openIHFDashboard, isLoading: isLoadingIHFLink } = useIHFlink(xsrf)
  const user: IUserProfile = useSelector((state: any) => state.userState.user)

  useEffect(() => {
    const newScript = document.createElement('script')
    newScript.setAttribute('id', 'profitwell-js')
    newScript.setAttribute('data-pw-auth', '9cb6cf4876061ec6b4b2cc5dd85c699b')
    const inlineScript = document.createTextNode("(function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)};a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+s.getElementById(o+'-js').getAttribute('data-pw-auth');m.parentNode.insertBefore(a,m);})(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');profitwell('start', { 'user_email': '" + user.email + "' });")
    newScript.appendChild(inlineScript)
    document.head.appendChild(newScript)
  }, [])

  return (
    <Box sx={{ m: isMobile ? 0 : 4, display: 'flex', justifyContent: 'center' }}>
      {location.state?.isEmailChange && <AlertNotification text="Email updated successfully" />}
      <Grid
        container
        spacing={{ xs: 2, sm: 2, md: 2, lg: 3 }}
      >
        <Grid item xs={12} sm={12} md={12} lg={6} style={{ borderRadius: '30px' }}>
          <MonthlyActivity />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <RecentLeads isLoadingIHFLink={isLoadingIHFLink} openIHFDashboard={openIHFDashboard} />
        </Grid>
        {/* <Grid item xs={12} sm={12} md={12}>
          <ActiveAds />
        </Grid> */}
        {user?.account.websiteUrl
          ? <Grid item xs={12} sm={12} md={12} lg={6}>
            <MonthlyAnalytics />
          </Grid>
          : null}
        {user.typeOfBusiness !== PROFILE_TYPE_BUSINESS.MORTGAGE && <Grid item xs={12} sm={12} md={12} lg={6}>
          <ActiveListings isLoadingIHFLink={isLoadingIHFLink} openIHFDashboard={openIHFDashboard}/>
        </Grid>}
      </Grid>
    </Box>
  )
}

export default HomePage
